import React from 'react';
import { i18n } from '../../i18n/translate.js';
import orderBy from 'lodash/orderBy';
import { DashboardCard } from '../DashboardCard/component.js';

var AnnouncementCard = function AnnouncementCard(_ref) {
  var _ref$systemMessages = _ref.systemMessages,
      systemMessages = _ref$systemMessages === void 0 ? [] : _ref$systemMessages,
      emptyStateImage = _ref.emptyStateImage,
      height = _ref.height;

  var getEmptyComponent = function getEmptyComponent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: emptyStateImage
    }), /*#__PURE__*/React.createElement("div", null, i18n.t('There are no announcements at this time.')));
  };

  var announcements = orderBy(systemMessages.filter(function (item) {
    return item.view_locations.includes('dashboard');
  }), ['updated_at'], ['desc']);
  return /*#__PURE__*/React.createElement(DashboardCard, {
    type: "announcement",
    title: i18n.t('Announcements'),
    items: announcements,
    emptyComponent: getEmptyComponent(),
    height: height,
    getItemCardProps: function getItemCardProps(announcement) {
      return {
        title: announcement.title,
        description: announcement.content,
        hasRichTextContent: true
      };
    }
  });
};

AnnouncementCard.displayName = "AnnouncementCard";
export { AnnouncementCard };